import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=6c8e542e&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=6c8e542e&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8e542e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c8e542e')) {
      api.createRecord('6c8e542e', component.options)
    } else {
      api.reload('6c8e542e', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=6c8e542e&scoped=true", function () {
      api.rerender('6c8e542e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/receptionSupervise/roomManagement/detail.vue"
export default component.exports